import axios from 'axios';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const BASE_URL = API_BASE_URL;

export const addFamily = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL}/family/add`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};